import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const OperatorsPage = lazy(() =>
  import('@/pages/ads/operators/list-page').then((m) => ({ default: m.OperatorsPage })),
);

export const Route = createFileRoute('/_app/ads/operators/')({
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <OperatorsPage />
    </Suspense>
  ),
});
